import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, DynamicFormDto, DynamicPayloadDto} from "./dto";
import { Injectable } from "@angular/core";

abstract class HttpAgentAbstractService extends AbstractHttpService {
	constructor(httpClient: HttpClient, uri: string, authService: AuthService) {
		super(httpClient, uri, authService);
	}
	public getForm(): Observable<DynamicFormDto> {
		return super.doGet(true, "/form");
	}
	public get(id: number): Observable<DynamicFormDto> {
		return super.doGet(true, `/${id}`);
	}
	public create(payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/`, payload);
	}
	public edit(id: number, payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/${id}`, payload);
	}
	public getAll(): Observable<AgentDto[]> {
		return super.doGet(true, "/");
	}
}
@Injectable({
	providedIn: 'root'
})
export class HttpAgentAdminService extends HttpAgentAbstractService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/agent/admin', authService);
	}
}
@Injectable({
	providedIn: 'root'
})
export class HttpAgentFaoService extends HttpAgentAbstractService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/agent/fao', authService);
	}
}
@Injectable({
	providedIn: 'root'
})
export class HttpAgentUnderwriterService extends HttpAgentAbstractService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/agent/underwriter', authService);
	}
}

